import React, { useState } from "react";
import {
  AppBar,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  InputBase,
  Menu,
  MenuItem,
  Paper,
  Toolbar,
  Typography,
} from "@mui/material";
import WSDataGrid, {
  IColumns,
} from "../../../../Components/DataGrid/WSDataGrid";
import { WSIcons } from "../../../../commonFunctions/iIcons";
import WSSCheckBoxField from "../../../../Components/CheckBox/WSCheckBox";
import { useForm } from "react-hook-form";
import { IMetaData } from "../../../../Components/Dialog/WSCommonDialog";
import Store from "./Store";
import { openPopUp } from "../../../../Components/Dialog/OpenNewModal";


export const StoreList: React.FC<{ onClose: () => void }> = ({
  onClose,
}) => {
  const { control, register } = useForm();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [expandAnchorEl, setExpandAnchorEl] = useState<null | HTMLElement>(
    null
  );
  const menuOpen = Boolean(anchorEl);
  const dropdownOpen = Boolean(expandAnchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleExpandMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setExpandAnchorEl(event.currentTarget);
  };

  const handleExpandMenuClose = () => {
    setExpandAnchorEl(null);
  };
  
  const handleData = async (data: any) => {
    debugger;
    console.log("onsubmit===>", data); // You can perform any action with the submitted data here
  };
  const metadata: IMetaData = {
    title: "User Role",
    hideActions: false,
    content: (props: any, row: any) => (
      <Store {...props}/>
    ),
    actions: [
      {
        label: "Cancel",
        className: "ws-cancel",
        type: "button",
      },
      {
        label: "submit",
        type: "submit",
        onClick: handleData,
        autoFocus: true,
      },
    ],
    isDragable: true,
  };
  const handleClick = () => {
    openPopUp(metadata, handleData);
  };
  const columns: IColumns[] = [
    {
      header: "Name",
      fieldName: "",
      tooltip: true,
    },
    
  ];

  return (
    <Grid
      container
      mt={10}
      direction="column"
      sx={{
        height: "100vh", // Make the container fill the full height
      }}
    >
      {/* Top AppBar */}
      <AppBar position="static" color="default" elevation={1}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Stores
          </Typography>
          <Typography variant="body2" sx={{ color: "gray", mr: 2 }}>
            1 Record(s)
          </Typography>
          <Paper
            component="form"
            sx={{
              display: "flex",
              alignItems: "center",
              width: 200,
              borderRadius: 1,
              p: "2px 4px",
              mr: 2,
            }}
          >
            <InputBase
              placeholder="Search"
              inputProps={{ "aria-label": "search users" }}
              sx={{ ml: 1, flex: 1 }}
            />
            <IconButton type="button" aria-label="search">
              <WSIcons.SearchIcon />
            </IconButton>
          </Paper>
          <IconButton onClick={handleExpandMenuOpen}>
            <WSIcons.ExpandMoreIcon />
          </IconButton>
          <Menu
  anchorEl={expandAnchorEl}
  open={dropdownOpen}
  onClose={handleExpandMenuClose}
  anchorOrigin={{
    vertical: "bottom",
    horizontal: "right",
  }}
  transformOrigin={{
    vertical: "top",
    horizontal: "right",
  }}
>
  <MenuItem>
    <WSSCheckBoxField
      id="showinactiveuser"
      {...register("showinactiveuser")}
      label="Show Inactive User"
      control={control}
      rules={{ required: true }}
      defaultValue={false}
    />
  </MenuItem>
 
  {/* Add Buttons in the Dropdown */}
  <Box
    sx={{
      display: "flex",
      justifyContent: "flex-end",
      p: 1,
      borderTop: "1px solid #ddd", // Optional: Border at the top of the buttons section
    }}
  >
    <Button
      variant="outlined"
      sx={{ color: "black", borderColor: "black", mr: 1 }}
    >
      <WSIcons.SearchIcon/>
    </Button>
    <Button variant="outlined"
      sx={{ color: "black", borderColor: "black", mr: 1 }}>
      <WSIcons.SyncIcon/>
    </Button>
  </Box>
</Menu>

          <IconButton onClick={handleMenuOpen}>
            <WSIcons.ViewListIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={menuOpen}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <MenuItem onClick={handleMenuClose}>Language</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      {/* User Table */}
      <Box
        sx={{
          flex: 1, // Pushes the footer to the bottom
          overflow: "auto", // Enables scrolling if the table content is large
        }}
      >
        <WSDataGrid id="itemGrid" title="" columns={columns} />
      </Box>

      {/* Footer Buttons */}
      <Box
        sx={{
          bgcolor: "#f4f4f4",
          p: 1,
          borderTop: "1px solid #ddd", // Optional: Adds a border to the top of the footer
        }}
      >
        <Grid container justifyContent="flex-end" spacing={1}>
          <Grid item>
            <Button
              variant="outlined"
              sx={{ color: "black", borderColor: "black" }}
              onClick={handleClick}
            >
              New
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              sx={{ color: "black", borderColor: "black" }}
            >
              Edit
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              sx={{ color: "black", borderColor: "black" }}
            >
              Delete
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              sx={{ color: "black", borderColor: "black" }}
              onClick={onClose}
            >
              Close
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
};
